module.exports = new __parcel__URL__("replaced.8c6c9165.mp3").toString();